/* eslint-disable jsx-a11y/anchor-is-valid */
import {StepProps} from '../IAppModels'

const Step2 = ({data, updateData}: StepProps) => {
  return (
    <div className='pb-5' data-kt-stepper-element='content'>
      <table className='table table-hover table-rounded table-striped border gy-7 gs-7'>
        <thead>
          <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
            <th>Número da proposta</th>
            <th>Tipo</th>
            <th>Urgente?</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>3231299</td>
            <td>Físico</td>
            <td>Não</td>
          </tr>
          <tr>
            <td>3421322</td>
            <td>Físico</td>
            <td>Não</td>
          </tr>
          <tr>
            <td>35762712</td>
            <td>Digital</td>
            <td>Sim</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export {Step2}
